export class WidgetsHelper {
  constructor(stateName, store) {
    this.stateName = stateName
    this.store = store
  }


  resetBreadcrumbs() {
    this.store.commit(`${this.stateName}/setParentsCurrentWidget`, [])
    this.store.commit(`${this.stateName}/setSelectedWidget`, { widget: undefined })
  }

  setupBreadcrumbs(parentWidgets) {
    this.store.commit(`${this.stateName}/setParentsCurrentWidget`, parentWidgets)
  }

  setSelectedWidget(widget, contract) {
    this.store.commit(`${this.stateName}/setSelectedWidget`, { widget, contract: contract || '' })
  }
}
